export default __webpack_public_path__ + "static/media/ff459838f826b56484e4295f06a20f35.png";